import { GET_LIST_OF_PROGRAMS, GET_LIST_OF_PROGRAMS_SUCCESS, GET_LIST_OF_PROGRAMS_ERROR, GET_LIST_OF_PROGRAMS_EMPTY } from '../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetListOfPrograms = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_OF_PROGRAMS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_LIST_OF_PROGRAMS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_LIST_OF_PROGRAMS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_LIST_OF_PROGRAMS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetListOfPrograms;
